export default "__VITE_ASSET__BqOUb37k__"